import { useLocationContext } from "../../client/contexts/LocationContext";
import { DashboardLayout } from "../../client/components/Sidebar";
import DefaultReceptionPage from "./DefaultReceptionPage";
import LocationReceptionPage from "./LocationReceptionPage";
import LoadingSpinner from "../../admin/layout/LoadingSpinner";
import { pageLayoutStyles } from "../../components/ui/page-layout";

export default function ReceptionPage() {
  const { selectedLocation, locations, isLoading, error } =
    useLocationContext();

  if (isLoading) {
    return (
      <DashboardLayout>
        <div className={pageLayoutStyles.layout.container}>
          <div className="flex items-center justify-center min-h-[400px]">
            <LoadingSpinner />
          </div>
        </div>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <div className={pageLayoutStyles.layout.container}>
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-red-600 mb-2">
                Error Loading Locations
              </h2>
              <p className="text-muted-foreground">
                {error.message || "Something went wrong"}
              </p>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  // Show default reception page when no location is selected
  if (!selectedLocation) {
    return <DefaultReceptionPage locations={locations} />;
  }

  // Show location-specific reception page
  return <LocationReceptionPage location={selectedLocation} />;
}
